/* src/app/order/components/order-pricing/product-pricing/product-pricing.style.scss */
.order-pricing {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
}
@media screen and (max-width: 1279px) {
  .order-pricing {
    display: flex;
    flex-wrap: wrap;
  }
  .order-pricing price-card {
    flex-basis: 50%;
  }
  .order-pricing price-card:nth-child(odd) {
    padding-right: 10px;
  }
  .order-pricing price-card:nth-child(even) {
    padding-left: 10px;
  }
}
@media screen and (max-width: 767px) {
  .order-pricing price-card {
    flex-basis: 100% !important;
  }
  .order-pricing price-card:nth-child(odd) {
    padding-right: 0;
  }
  .order-pricing price-card:nth-child(even) {
    padding-left: 0;
  }
}
/*# sourceMappingURL=product-pricing.style.css.map */
